export default {
  title: 'アカウント情報',
  emailLoginId: 'メールアドレス／ログインID',
  password: 'パスワード',
  changeEmail: 'メールアドレスを変更する',
  changePassword: 'パスワードを変更する'
}
